// Service configuration for Brooklyn Community Christian Church
// All times in 24-hour format, timezone: America/New_York (EST/EDT)

export const REGULAR_SERVICES = [
  {
    id: 'chinese',
    startTime: '09:30',  // 9:30 AM
    endTime: '11:00',    // 11:00 AM
    type: 'regular',
    gradient: {
      start: 'var(--plum-700)',
      end: 'var(--plum-500)'
    },
    cardStyle: 'diagonal-top'
  },
  {
    id: 'english',
    startTime: '11:30',  // 11:30 AM
    endTime: '13:00',    // 1:00 PM
    type: 'regular',
    gradient: {
      start: 'var(--terracotta)',
      end: '#D87856'
    },
    cardStyle: 'diagonal-bottom'
  }
];

export const SPECIAL_SERVICES = [
  {
    key: 'easterSunday',
    date: "2026-04-05",
    startTime: '10:00',
    endTime: '12:00'
  },
  {
    key: 'mothersDay',
    date: "2026-05-10",
    startTime: '10:00',
    endTime: '12:00'
  },
  {
    key: 'fathersDay',
    date: "2026-06-21",
    startTime: '10:00',
    endTime: '12:00'
  }
];

// Combined service styling
export const COMBINED_SERVICE_STYLE = {
  gradient: {
    start: '#6B7F5E',
    end: '#8FA878'
  },
  cardStyle: 'diagonal-special'
};

// Status indicator timings (in minutes)
export const STATUS_CONFIG = {
  startingSoonMinutes: 10,  // Show "Starting soon" 10 min before
  justFinishedMinutes: 10   // Show "Just finished" 10 min after
};
